import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="map-page-header">
        <h1>Price Comparison Map</h1>
      </div>
    </header>
  );
};

export default Header;